<template>
  <div>
    <div
      v-if="user.isForgetActive"
      class="popup-wrap register-wrap"
      :class="{ active: user.isForgetActive }"
    >
      <div class="popup-box popup-box-md fullScreen-md">
        <a class="popup-close" @click="deactivatePopup"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup popup-padding m-loginRegister-frame">
          <form class="row-frame dep-form-frame reg-popupBox">
            <h4 class="register-title font-w-b text-align-L">
              {{ $t("Bao.forget_password") }}
            </h4>
            <div class="reg-form-area">
              <div class="colu colu-auto">
                <label class="colu-sm-12 colu-12 colu-form-label title-label">
                  {{ $t('Bao.registered_account_require') }}
                </label>
                <div class="colu-sm-12 colu-12">
                  <input
                    v-model="postForm.username"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': errors.has('username')}"
                    type="text"
                    name="username"
                    :data-vv-as="$t('Bao.username')"
                    :placeholder="$t('Bao.registered_account')"
                    :required="true"
                    autocomplete="off"
                  >
                </div>
                <div v-if="errors.has('username')" class="input-feedback text-align-R">
                  {{ $t("Bao.user_name_error") }}
                </div>
              </div>

              <div v-if="type === 1" class="colu colu-auto">
                <label for="eMail" class="colu-sm-12 colu-12 colu-form-label title-label">
                  {{ $t('Bao.registered_email_require') }}
                </label>
                <div class="colu-sm-12 colu-12">
                  <input
                    id="eMail"
                    v-model="postForm.email"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': errors.has('check_email')}"
                    type="text"
                    name="check_email"
                    :data-vv-as="$t('Bao.check_email')"
                    autocomplete="off"
                    :placeholder="$t('Bao.registered_email')"
                  >
                </div>
                <div v-if="errors.has('check_email')" class="input-feedback text-align-R">
                  {{ $t("Bao.email_error") }}
                </div>
              </div>

              <div v-if="registerNeedPhone" class="colu colu-auto">
                <label class="colu-sm-12 colu-12 colu-form-label title-label" for="ご登録の携帯番号を入力してください">{{ $t("Bao.phone") }}</label>

                <div class="colu colu-sm-12 colu-12 country-select-frame">
                  <div class="colu-3 colu-sm-2 country-select-box" :class="{ active: isActive }" @click="toggleActive">
                    <div class="form-select-1 country-select">
                      <div class="form-select-value">
                        <div class="country-flag" />
                        <div class="country-code">
                          {{ selectedCode }}
                        </div>

                        <div class="country-list-box">
                          <ul class="country-list">
                            <li
                              v-for="(code, key) in brand.supportPhoneCode"
                              :key="key"
                              @click.stop="selectCode(code)"
                            >
                              <div class="country-flag" />
                              <div class="country-code">
                                {{ code }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <i class="fa-solid fa-angle-right " aria-hidden="true" />
                  </div>
                  <div class="colu-9 colu-sm-10 number-box">
                    <input
                      id="phoneNumber"
                      v-model="postForm.phone"
                      v-validate="'required'"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('check_phone')}"
                      type="text"
                      name="check_phone"
                      :placeholder="$t('Bao.forget_password_phone')"
                      @input="onlyNumbers"
                    >
                  </div>
                </div>
                <div v-if="errors.has('check_phone')" class="input-feedback text-align-R">
                  {{ $t("Bao.login_phone_error") }}
                </div>
              </div>

              <div>
                <div class="form-button form-ft">
                  <button
                    class="btn-primary goTo-fun-newPassword"
                    type="button"
                    :disabled="isSendButtonDisabled"
                    @click.prevent="submit"
                  >
                    <span>{{ $t("Bao.send") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 手機驗證彈窗 -->
    <div v-if="registerNeedPhone && isVerify" class="popup-wrap register-wrap fun-sec-authen" :class="{ active: isVerify }">
      <div class="popup-box fullScreen-md">
        <a class="popup-close" href="javascript:;" @click="closeVerify('verify')"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup popup-padding">
          <form class="row-frame dep-form-frame reg-popupBox">
            <h4 class="register-title font-w-b text-align-L">
              {{ $t("Bao.verify_phone") }}
            </h4>
            <div class="reg-form-group">
              <div class="reg-form-area">
                <div class="colu colu-auto">
                  <label class="colu-12 colu-form-label title-label let-lessen">
                    {{ $t("Bao.verify_phone_code") }}
                  </label>
                  <div class="colu-12">
                    <input
                      v-model="postForm.validate_code"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('phoneValidateCode')}"
                      type="text"
                      name="phoneValidateCode"
                      autocomplete="off"
                    >
                  </div>
                  <div v-if="errors.has('phoneValidateCode')" class="input-feedback text-align-R">
                    {{ $t("Bao.validate_code_error") }}
                  </div>
                </div>

                <div>
                  <div class="form-button form-ft">
                    <button
                      class="btn-primary"
                      type="button"
                      :disabled="isPhoneButtonDisabled"
                      @click.prevent="getVerificationPop"
                    >
                      <span>{{ $t("Bao.verify_register") }}</span>
                    </button>
                  </div>
                </div>

                <div class="colu-auto">
                  <i class="icon-alert"><img :src="$getThemeImagePath('icon-detail.png')" alt=""></i>
                  <b>{{ $t("Bao.email_notice_4") }}</b>
                  <span class="let-lessen">{{ $t("Bao.phone_notice_5") }}</span>
                </div>
                <div class="colu-auto">
                  <b>{{ $t("Bao.email_notice_1") }}</b>
                </div>
                <div class="colu-auto">
                  <p>
                    {{ $t("Bao.phone_notice_3") }}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <div class="authen-btn-wrap">
                <button
                  class="btn-primary goTo-fun-sec-authen btn-mb-w-100"
                  @click.prevent="changePhone"
                >
                  <span>{{ $t("Bao.phone_change") }}</span>
                </button>

                <button
                  class="btn-primary goTo-fun-sec-authen btn-mb-w-100 btn-resend"
                  :disabled="timerCount"
                  @click.prevent="getCode"
                >
                  <div id="countdown-container">
                    <span id="countdown">{{ timerCount ? '(' + limitSecond + 's)' : $t('Bao.get_verification_code') }}</span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- phone 設定新密碼 -->
    <div v-if="limitVerify" class="popup-wrap register-wrap fun-newPassword" :class="{ active: limitVerify }">
      <div class="popup-box popup-box-md fullScreen-md">
        <a class="popup-close" @click="closeVerify('setting')"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup popup-padding m-loginRegister-frame">
          <form class="row-frame dep-form-frame reg-popupBox">
            <h4 class="register-title font-w-b text-align-L">
              {{ $t("Bao.set_new_pass_1") }}
            </h4>
            <div class="reg-form-area">
              <div class="colu colu-auto">
                <label class="colu-sm-12 colu-12 colu-form-label title-label">
                  {{ $t("Bao.set_new_pass_2") }}
                </label>

                <div class="colu-sm-12 colu-12">
                  <input
                    ref="new_pass"
                    v-model="postForm.new_password"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': passErrors && passErrors.length > 0 }"
                    type="password"
                    name="new_pass"
                    :placeholder="$t('Bao.set_new_pass_3')"
                    @input="checkPassErrors"
                  >
                  <div v-for="error in passErrors" :key="error" class="input-feedback text-align-R">
                    {{ error }}
                  </div>
                </div>
              </div>

              <div class="colu colu-auto">
                <div class="colu-sm-12 colu-12">
                  <input
                    v-model="postForm.confirmPassword"
                    v-validate="'required|confirmed:new_pass'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': errors.has('confirm_pass') }"
                    type="password"
                    :placeholder="$t('Bao.set_new_pass_4')"
                    name="confirm_pass"
                  >
                </div>
                <div v-if="errors.has('confirm_pass')" class="input-feedback text-align-R">
                  {{ $t("Bao.new_password_error") }}
                </div>
              </div>

              <div class="colu-12">
                <div class="form-button form-ft goTo-fun-infor-error">
                  <button
                    class="btn-primary"
                    :disabled="updatePassBtn"
                    @click.prevent="handleUpdatePhone"
                  >
                    <span>{{ $t("Bao.send") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!--  phone 密碼重新設定成功 -->
    <div v-if="isUpdatePassSuccess" class="popup-wrap fun-infor-success" :class="{ 'active': isUpdatePassSuccess }">
      <div class="popup-box popup-md-w95">
        <a class="popup-close" @click="goHome"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup popup-padding">
          <div class="row-frame dep-form-frame reg-popupBox">
            <div class="colu-12">
              <div class="infor-content">
                <i class="fa-solid fa-circle-check infor-icon-success text-center" />
                <div class="infor-title text-center">
                  {{ $t("Bao.set_new_pass_success_1") }}
                </div>
                <div class="infor-describe text-center">
                  {{ $t("Bao.set_new_pass_success_2") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { requestForgotPassword, validateCodInfo, forgotPassword } from '@/api/user'
import { setErrorMessage, showNotice } from '@/utils/tool'
import { mapGetters } from 'vuex'

export default {
  name: 'Forget',

  data() {
    const postForm = {
      username: '',
      email: '',
      completeEmail: '',
      phone: '',
      validate_code: '',
      new_password: '',
      confirmPassword: ''
    }

    return {
      actionLoading: false,
      postForm,
      limitVerify: false,
      limitSecond: 180,
      isVerify: false,
      type: 1, // 1: email, 2: phone
      timerCount: true,
      isUpdatePassSuccess: false,
      currentTimerId: null,
      passErrors: [],
      isActive: false,
      selectedCode: ''
    }
  },
  computed: {
    ...mapGetters(['brand', 'user']),
    registerNeedPhone() {
      return this.$store.state.brand.permissionInfo.register_need_phone
    },
    isSendButtonDisabled() {
      const usernameValidate = this.postForm.username === null || this.postForm.username.trim() === ''
      if (this.type === 1) {
        /* eslint-disable no-unused-vars */
        const { email, username, ...rest } = this.postForm
        const formToCheck = { email, username }
        const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
        const emailValidate = this.postForm.email === null || this.postForm.email.trim() === ''
        return usernameValidate || emailValidate || this.actionLoading || hasEmptyFields
      } else {
        const { username, phone, ...rest } = this.postForm
        const formToCheck = { phone, username }
        const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
        const phoneValidate = this.postForm.phone === null || this.postForm.phone.trim() === ''
        return usernameValidate || phoneValidate || this.actionLoading || hasEmptyFields
      }
    },
    isPhoneButtonDisabled() {
      return this.postForm.validate_code === null || this.postForm.validate_code.trim() === ''
    },
    updatePassBtn() {
      const hasErrors = this.errors.any()
      /* eslint-disable no-unused-vars */
      const { username, email, completeEmail, phone, validate_code, ...formToCheck } = this.postForm

      const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
      return hasErrors || hasEmptyFields || this.passErrors.length > 0
    }
  },
  watch: {
    'postForm.email'(newValue) {
      if (this.type === 1) {
        this.postForm.completeEmail = this.postForm.email
      }
    },
    'postForm.validate_code': function(newValue) {
      if (this.registerNeedPhone && this.isVerify) {
        if (!newValue || newValue.trim() === '') {
          this.$validator.errors.add({
            field: 'phoneValidateCode',
            msg: this.$t('Bao.validate_code_error')
          })
        } else {
          this.$validator.errors.remove('phoneValidateCode')
        }
      }
    },
    'brand.supportPhoneCode': {
      handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedCode) {
          this.selectedCode = newVal[0]
        }
      },
      immediate: true
    }
  },
  created() {
    this.initPostForm()
    if (this.registerNeedPhone) {
      this.type = 2
    }
  },
  methods: {
    submit() {
      if (this.type === 1) {
        this.handleUpdateEmail()
      } else {
        this.openPhoneVerify()
      }
    },
    handleUpdateEmail() {
      const self = this
      this.actionLoading = true
      this.postForm.email = this.postForm.completeEmail

      requestForgotPassword(this.postForm).then(response => {
        this.initPostForm()
        this.limitVerify = false
        showNotice(this.$t('Bao.send_email_success'), function() {
          self.$store.commit('SET_FORGET_OPEN', false)
        }, true, false, '')
      }).catch((error) => {
        setErrorMessage(error.response, this.errors)
      }).finally((e) => {
        this.actionLoading = false
      })
    },
    openPhoneVerify() {
      this.getCode()
    },
    getCode() {
      const phoneToUse = this.postForm.phone
      const formattedPhone = this.selectedCode + phoneToUse
      this.postForm.phone = formattedPhone

      requestForgotPassword(this.postForm).then(response => {
        showNotice(this.$t('Bao.send_phone_success'))
        this.$store.commit('SET_FORGET_OPEN', false)
        this.timerCount = true
        this.isVerify = true

        if (this.currentTimerId === null) {
          this.countDown()
        }
      }).catch((error) => {
        this.postForm.phone = phoneToUse
        showNotice(error.response.data.msg)
      })
    },
    getVerificationPop() {
      validateCodInfo({ validate_code: this.postForm.validate_code }).then(response => {
        this.isVerify = false
        this.limitVerify = true
        this.$store.commit('SET_FORGET_OPEN', false)
        this.$store.commit('SET_RESET_PASSWORD_OPEN', true)
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    handleUpdatePhone() {
      forgotPassword(this.postForm).then(response => {
        this.isUpdatePassSuccess = true
        this.limitVerify = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    closeVerify(status) {
      if (status === 'verify') {
        this.$store.commit('SET_FORGET_OPEN', true)
        this.isVerify = false
      } else {
        this.$store.commit('SET_RESET_PASSWORD_OPEN', false)
        this.limitVerify = false
      }

      this.initPostForm()
    },
    deactivatePopup() {
      this.initPostForm()
      this.$store.commit('SET_FORGET_OPEN', false)
    },
    onlyNumbers() {
      // 移除非數字字符
      this.postForm.phone = this.postForm.phone.replace(/\D/g, '')
    },
    changePhone() {
      this.isVerify = false
      this.postForm.phone = ''
      this.$store.commit('SET_FORGET_OPEN', true)
    },
    goHome() {
      this.limitVerify = false
      this.isUpdatePassSuccess = false
      this.$store.commit('SET_LOGIN_OPEN', true)
    },
    checkPassErrors() {
      this.passErrors = []

      if (!this.postForm.new_password) {
        this.passErrors.push(this.$t('Bao.new_password_error'))
      } else if (this.postForm.new_password && this.postForm.new_password.trim() !== '') {
        const passwordRegex = /^[a-zA-Z0-9][a-zA-Z0-9]*$/
        const hasWhitespace = /\s/

        if (hasWhitespace.test(this.postForm.new_password)) {
          this.passErrors.push(this.$t('Bao.password_restrict_chars'))
        } else if (!passwordRegex.test(this.postForm.new_password)) {
          this.passErrors.push(this.$t('Bao.password_restrict_chars'))
        } else if (this.postForm.new_password.length < 6) {
          this.passErrors.push(this.$t('Bao.password_restrict'))
        } else if (this.postForm.new_password.length > 20) {
          this.passErrors.push(this.$t('Bao.password_restrict_20'))
        }
      }
    },
    initPostForm() {
      this.postForm = {
        username: '',
        email: '',
        completeEmail: '',
        phone: '',
        validate_code: '',
        new_password: '',
        confirmPassword: ''
      }

      this.errors.clear()
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
          this.currentTimerId = null
        }
      }, 1000)

      this.currentTimerId = timer
    },
    toggleActive() {
      this.isActive = !this.isActive
    },
    selectCode(code) {
      this.isActive = false
      this.selectedCode = code
    }
  }
}
</script>
